import dayjs from "utils/dayjs";

export function formatDate(timestamp: number, format = "DD/MM/YYYY") {
  return dayjs.unix(timestamp).format(format);
}

export function formatDateTime(timestamp: number) {
  if (timestamp > 0) {
    return dayjs.unix(timestamp).format("HH:mm, DD/MM/YYYY");
  }

  return "--";
}

export function formatDateDay(timestamp: number) {
  return dayjs.unix(timestamp).format("dddd, MM-DD-YYYY");
}

export function generateTimeSeries(
  step: number,
  addHour = 0,
  format = "h:mm a",
) {
  const dt = new Date(1970, 0, 1);
  const rc = [];
  while (dt.getDate() === 1) {
    rc.push(dayjs(dt).add(addHour, "hour").format(format));
    dt.setMinutes(dt.getMinutes() + step);
  }
  return rc;
}

export function generateDuration() {
  let seconds = 300;
  const durations = [];
  while (seconds <= 60 * 60 * 12) {
    const label = secondToMinuteString(seconds);
    durations.push({
      label,
      value: seconds,
    });
    seconds += 300;
  }
  return durations;
}

export function secondToMinuteString(second: number) {
  const h = Math.floor(second / 3600);
  const m = (second % 3600) / 60;
  if (h == 0) {
    return `${m}m`;
  }

  if (m == 0) {
    return `${h}h`;
  }

  return `${h}h ${m}m`;
}
